function random(min, max) {
  return Math.round(Math.random() * (max - min)) + min
}

function angle2radius(angle) {
  return Math.PI * angle / 180
}

function easeOut(x) {
  return Math.sqrt(1 - Math.pow(x - 1, 2))
}

function easeIn(x) {
  return 1 - Math.sqrt(1 - x * x)
}

function loopTick(fn) {
  return window.requestAnimationFrame(fn) || setTimeout(fn, 1000 / 60)
}

const Colors = ["#EF5350", "#EC407A", "#AB47BC", "#7E57C2", "#5C6BC0", "#42A5F5", "#29B6F6", "#26C6DA", "#26A69A", "#66BB6A", "#9CCC65", "#D4E157", "#FFEE58", "#FFCA28", "#FFA726", "#FF7043", "#8D6E63", "#BDBDBD", "#78909C"]
const Width = window.innerWidth
const Height = window.innerHeight
const WidthRange = [2, 6]
const HeightRange = [2, 6]
const Num = [20, 50]
const Ox = [0, Width - 10]
const Oy = [60, 120]
const RotationRange = [0, 180]
const RotateSpeedRange = [1, 8]
const DurationRange = [2000, 2500]
const UpDuration = [500, 800]

class Confetti {
  constructor(context) {
    this.context = context
    this.reset()
  }

  reset() {
    this.width = random.apply(null, WidthRange)
    this.height = random.apply(null, HeightRange)
    this.color = Colors[random(0, Colors.length - 1)]
    this.vx = 0.15 * (Math.random() > 0.5 ? 1 : -1)
    this.vy = 0.5
    this.va = 1
    this.vr = random.apply(null, RotateSpeedRange)
    this.ox = random.apply(null, Ox)
    this.oy = random.apply(null, Oy)
    this.oa = random.apply(null, RotationRange)
    this.or = angle2radius(this.oa)
    this.duration = random.apply(null, DurationRange)
    this.__uduration = random.apply(null, UpDuration)
    this.__dduration = this.duration - this.__uduration
    this.__delay = random(0, 200)
    this.__sttime = Date.now() + this.__delay
    this.__y = 0
    this.x = this.ox
    this.y = this.oy
    this.angle = this.oa
    this.progress = 0
  }

  update() {
    const time = Date.now() - this.__sttime
    this.progress = time / this.duration
    this.progress = this.progress > 1 ? 1 : this.progress
  }

  next() {
    let time = Date.now() - this.__sttime
    if (time >= this.__uduration) {
      time -= this.__uduration
      time = time > this.__uduration ? this.__uduration : time
      this.vx = 0
      this.y = this.__y + (this.context.canvas.height - this.__y + 15) * easeIn(time / this.__uduration)
    } else {
      this.x += this.vx
      this.y = this.oy - this.oy * easeOut(time / this.__dduration) + 5
      this.__y = this.y
    }
    this.x += this.vx
    this.angle += this.va
    this.rotation = angle2radius(this.angle)
  }

  render() {
    this.update()
    if (this.progress < 0 || this.progress >= 1) return
    this.next()
    this.context.save()
    this.context.fillStyle = this.color

    const width = this.width * Math.abs(
      Math.sin(this.progress * Math.PI * 2 * this.vr)
    )

    const cx = this.x + (this.width - width) / 2
    const cy = this.y + this.height / 2

    this.context.translate(cx, cy)
    this.context.rotate(this.rotation)
    this.context.translate(-cx, -cy)

    this.context.fillRect(cx, cy, width, this.height)
    this.context.restore()
  }
}

export default class Paint {
  constructor(canvas) {
    this.canvas = canvas
    this.context = canvas.getContext('2d')
    this.sprites = Array(random.apply(null, Num)).fill(0).map(item => {
      return new Confetti(this.context)
    })
    this.render()
  }

  render() {
    if (!this.canvas) {
      console.log('Confetti Destoryed')
      return
    }
    this.context.clearRect(0, 0, Width, Height)
    this.sprites.forEach(item => {
      item.progress === 1 && item.reset()
      item.render()
    })
    loopTick(this.render.bind(this))
  }
}
